import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import cookie from 'js-cookie';
import { getParam } from "./url.js";
/**
 * 判断系统环境模块
 * @module env
 * @example

import { env } from '@zz-common/zz-utils'

console.log(env.$isServer) // false

 */

/**
 * 是否服务器端
 * @constant {Boolean}
 */
export var $isServer = typeof window === 'undefined';
var UA = $isServer ? '' : navigator.userAgent.toLowerCase();

/**
 * 是否鸿蒙端
 * @constant {Boolean}
 */
export var $isOpenHarmony = /openharmony/.test(UA);

/**
 * 是否 Android 端
 * @constant {Boolean}
 */
export var $isAndroid = /android/.test(UA);

/**
 * 是否 iOS 端
 * @constant {Boolean}
 */
export var $isIOS = /ios|iphone|ipad|ipod/.test(UA);

/**
 * 是否转转 APP 端
 * @constant {Boolean}
 */
export var $isZZ = /58zhuanzhuan/.test(UA);
/**
 * 是否找靓机 APP 端
 * @constant {Boolean}
 */
export var $isZlj = /zhaoliangji/.test(UA);

/**
 * 是否采货侠 APP 端
 * @constant {Boolean}
 */
export var $isChx = /zzhunter|crmHunter|thunderHunter/.test(UA);

/**
 * 是否微信端（包括小程序）
 * @constant {Boolean}
 */
export var $isWechat = /micromessenger/.test(UA);

/**
 * 是否找靓机新webview
 * @constant {Boolean}
 */
export var $isZljNewWebview = /zhaoliangji-v2/g.test(UA) && (getParam('needNewWebview') == '1' || getParam('needNewWebView') == '1' || compareVersion(cookie.get('v') || '0.0.0', '9.1.10') >= 0);

/**
 * 是否微信小程序
 * @constant {Boolean}
 */
export var $isMiniprogram = !$isServer && (/miniprogram/.test(UA) || window.__wxjs_environment === 'miniprogram');

/**
 * 是否 转转微信小程序
 * @constant {Boolean}
 */
export var $isZzMiniprogram = function $isZzMiniprogram() {
  try {
    return getParam('__t') == 103 && $isMiniprogram;
  } catch (error) {
    console.error(error);
  }
};
/**
 * 是否 找靓机微信小程序
 * @constant {Boolean}
 */
export var $isZljMiniprogram = function $isZljMiniprogram() {
  try {
    return getParam('__t') == 141 && $isMiniprogram;
  } catch (error) {
    console.error(error);
  }
};

/**
 * 是否 iPhone X 系列（需要底部适配）
 * @constant {Boolean}
 */
export var $isiPhoneX = function () {
  if (!$isIOS) return false;
  var _window$screen = window.screen,
    width = _window$screen.width,
    height = _window$screen.height;
  var isiPhoneXs = window.devicePixelRatio === 3 && width === 375 && height === 812;
  var isiPhoneXsMax = window.devicePixelRatio === 3 && width === 414 && height === 896;
  var isiPhoneXr = window.devicePixelRatio === 2 && width === 414 && height === 896;
  var isiPhone12 = window.devicePixelRatio === 3 && width === 390 && height === 844;
  var isiPhone12Max = window.devicePixelRatio === 3 && width === 428 && height === 926;
  var isiPhone14Pro = window.devicePixelRatio === 3 && width === 393 && height === 852;
  var isiPhone14ProMax = window.devicePixelRatio === 3 && width === 430 && height === 932;
  return isiPhoneXs || isiPhoneXsMax || isiPhoneXr || isiPhone12 || isiPhone12Max || isiPhone14Pro || isiPhone14ProMax;
}();
/**
 * 是转转/找靓机/采货侠app
 * @constant {Boolean}
 */
export var $isZzZljChxApp = $isZlj || $isZZ || $isChx;
/**
 * 是否 iPhone 12 系列
 * @constant {Boolean}
 */
export var $isiPhone12 = function () {
  if (!$isIOS) return false;
  var _window$screen2 = window.screen,
    width = _window$screen2.width,
    height = _window$screen2.height;
  var isiPhoneMini = window.devicePixelRatio === 3 && width === 360 && height === 780;
  var isiPhonePro = window.devicePixelRatio === 3 && width === 390 && height === 844;
  var isiPhoneProMax = window.devicePixelRatio === 3 && width === 428 && height === 926;
  return isiPhoneMini || isiPhonePro || isiPhoneProMax;
}();
/**
 * 获取 iphone 版本号
 * @method getIphoneVersion
 * @return {String} iphone版本号
 */

export var getIphoneVersion = function getIphoneVersion() {
  var str = UA;
  var ver = '0.0.0';
  try {
    var m = str.match(/cpu iphone os (.*?) like mac os/);
    if (m) ver = m[1].replace(/_/g, '.');
  } catch (error) {
    console.error('getIOSVersion', error);
  }
  return ver;
};

/**
 * 获取 Android 版本号
 * @method getAndroidVersion
 * @return {String} Android版本号
 */
export var getAndroidVersion = function getAndroidVersion() {
  var str = UA;
  var ver = '0.0.0';
  try {
    var m = str.match(/Android (.*?);/);
    if (m) ver = m[1];
  } catch (error) {
    console.error('getIOSVersion', error);
  }
  return ver;
};
/**
 * 获取 转转app 版本号 (cookie v)
 * @method getZZVersion
 * @return {String} 转转app 版本号
 */
export var getZZVersion = function getZZVersion() {
  // const str = UA
  var ver = '0.0.0';
  try {
    // UA 中
    // const m = str.match(/zzVersion\/(.*?) /)
    // if (m) ver = m[1]
    // cookie 中
    var v = cookie.get('v');
    if (v) ver = v;
  } catch (error) {
    console.error('getZZVersion', error);
  }
  return ver;
};
/**
 * 版本号比较
 * @method compareVersion
 * @param {String} v1 版本号1，形如"2.2.3"
 * @param {String} v2 版本号2，形如"2.2.4"
 * @return {Number} 比较结果，[-1 小于 | 0 等于 | 1 大于]
 */
export function compareVersion(v1, v2) {
  var seq1 = v1.split('.').map(function (subVersion) {
    return parseInt(subVersion, 10);
  });
  var seq2 = v2.split('.').map(function (subVersion) {
    return parseInt(subVersion, 10);
  });
  var len1 = seq1.length;
  var len2 = seq2.length;
  var commonLen = Math.min(len1, len2);
  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] !== seq2[i]) {
      return seq1[i] < seq2[i] ? -1 : 1;
    }
  }
  return len1 === len2 ? 0 : len1 < len2 ? -1 : 1;
}
export default {
  $isOpenHarmony: $isOpenHarmony,
  $isServer: $isServer,
  $isAndroid: $isAndroid,
  $isIOS: $isIOS,
  $isZZ: $isZZ,
  $isWechat: $isWechat,
  $isMiniprogram: $isMiniprogram,
  $isZljNewWebview: $isZljNewWebview,
  $isiPhoneX: $isiPhoneX,
  $isiPhone12: $isiPhone12,
  $isZlj: $isZlj,
  $isChx: $isChx,
  $isZzZljChxApp: $isZzZljChxApp,
  $isZzMiniprogram: $isZzMiniprogram(),
  $isZljMiniprogram: $isZljMiniprogram(),
  compareVersion: compareVersion,
  getAndroidVersion: getAndroidVersion,
  getIphoneVersion: getIphoneVersion,
  getZZVersion: getZZVersion
};